/* ============================================
   SPLINE 3D — Linee page integration
   3 separate Spline scenes, one per carousel slide.
   Each syncs position/opacity/scale with the carousel.
   ============================================ */

import { Application } from 'https://unpkg.com/@splinetool/runtime@1.12.96/build/runtime.js';

(async function () {
  // Skip 3D on mobile/tablet — PNG shown instead
  if (window.innerWidth <= 990) {
    window.dispatchEvent(new Event('spline-ready'));
    return;
  }

  // --- Configuration per slide ---
  // Reads from window.__NYMPHAI_SLIDES__ if set by Liquid (dynamic collection mode).
  // Falls back to hardcoded 3-slide setup for static HTML preview.
  var _slidesData = window.__NYMPHAI_SLIDES__;
  var SLIDES;
  if (_slidesData && _slidesData.length > 0) {
    SLIDES = _slidesData.map(function (s, i) {
      return {
        canvasId: s.canvasId || ('spline-canvas-' + (i + 1)),
        scene: s.scene,
        objectName: 'nymphai_cosmetic',
        position: { x: 21, y: -49, z: -217 },
        rotation: { x: -0.01, y: 6.642, z: 0 },
        scaleMultiplier: 1,
        preserveProportions: true,
      };
    });
  } else {
    var _defaultScene = (window.__NYMPHAI_ASSETS__ && window.__NYMPHAI_ASSETS__.splineScene) || '';
    SLIDES = [
      { canvasId: 'spline-canvas-1', scene: _defaultScene, objectName: 'nymphai_cosmetic', position: { x: 21, y: -49, z: -217 }, rotation: { x: -0.01, y: 6.642, z: 0 }, scaleMultiplier: 1, preserveProportions: true },
      { canvasId: 'spline-canvas-2', scene: _defaultScene, objectName: 'nymphai_cosmetic', position: { x: 21, y: -49, z: -217 }, rotation: { x: -0.01, y: 6.642, z: 0 }, scaleMultiplier: 1, preserveProportions: true },
      { canvasId: 'spline-canvas-3', scene: _defaultScene, objectName: 'nymphai_cosmetic', position: { x: 21, y: -49, z: -217 }, rotation: { x: -0.01, y: 6.642, z: 0 }, scaleMultiplier: 1, preserveProportions: true },
    ];
  }

  // Scale responsive
  var w = window.innerWidth;
  var baseScale = 1.55;
  if (w <= 1024) baseScale = 1.24;
  else if (w <= 1440) baseScale = 1.28;

  var positionY = -49;
  if (w <= 1440) positionY = 51;

  var track = document.querySelector('#prodotti .prodotti__track');
  if (!track) return;

  // --- Load scenes lazy: scene 1 subito, scene 2/3 quando la sezione si avvicina ---
  var instances = []; // { canvas, bottle, app, slideIndex }

  async function loadScene(cfg, index) {
    var canvas = document.getElementById(cfg.canvasId);
    if (!canvas) return null;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    var app = new Application(canvas);
    await app.load(cfg.scene);

    var bottle = app.findObjectByName(cfg.objectName);
    if (!bottle) {
      console.warn('Spline slide ' + (index + 1) + ': object "' + cfg.objectName + '" not found');
      return null;
    }

    bottle.position.x = cfg.position.x;
    bottle.position.y = positionY;
    bottle.position.z = cfg.position.z;
    bottle.rotation.x = cfg.rotation.x;
    bottle.rotation.y = cfg.rotation.y;
    bottle.rotation.z = cfg.rotation.z;

    var origScaleX = bottle.scale.x;
    var origScaleY = bottle.scale.y;
    var origScaleZ = bottle.scale.z;

    var mult = cfg.scaleMultiplier || 1;
    if (cfg.preserveProportions && origScaleX !== 0) {
      var ratioY = origScaleY / origScaleX;
      var ratioZ = origScaleZ / origScaleX;
      bottle.scale.x = baseScale * mult;
      bottle.scale.y = baseScale * mult * ratioY;
      bottle.scale.z = baseScale * mult * ratioZ;
    } else {
      bottle.scale.x = baseScale * mult;
      bottle.scale.y = baseScale * mult;
      bottle.scale.z = baseScale * mult;
    }

    var autoRotate = gsap.to(bottle.rotation, {
      y: '+=6.283',
      duration: 8,
      ease: 'none',
      repeat: -1,
      paused: true,
    });

    var shadow = document.createElement('div');
    shadow.className = 'spline-shadow';
    shadow.style.cssText = 'position:fixed; left:50%; bottom:14%; transform:translateX(-50%); width:220px; height:60px; border-radius:50%; background:radial-gradient(ellipse at 50% 30%, rgba(0,0,0,0.22) 0%, rgba(0,0,0,0.12) 30%, rgba(0,0,0,0.04) 60%, transparent 100%); filter:blur(8px); z-index:8999; pointer-events:none; visibility:hidden;';
    document.body.appendChild(shadow);

    return { canvas: canvas, bottle: bottle, app: app, slideIndex: index, autoRotate: autoRotate, shadow: shadow, preserveProportions: cfg.preserveProportions, ratioY: origScaleY / (origScaleX || 1), ratioZ: origScaleZ / (origScaleX || 1), scaleMultiplier: mult };
  }

  // Carica subito solo la scena 1 (sblocca il preloader)
  var inst1 = await loadScene(SLIDES[0], 0);
  if (inst1) instances.push(inst1);

  // Signal preloader che Spline è pronto (non aspetta le scene 2/3)
  window.dispatchEvent(new Event('spline-ready'));

  // Lazy load scene 2 e 3 quando #prodotti-wrap entra nel viewport (300px prima)
  if (SLIDES.length > 1) {
    var wrap = document.querySelector('#prodotti-wrap');
    var lazyTarget = wrap || document.body;
    var remainingLoaded = false;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || remainingLoaded) return;
      remainingLoaded = true;
      observer.disconnect();
      Promise.all(SLIDES.slice(1).map(function (cfg, i) {
        return loadScene(cfg, i + 1);
      })).then(function (results) {
        results.forEach(function (r) { if (r) instances.push(r); });
      });
    }, { rootMargin: '300px 0px' });
    observer.observe(lazyTarget);
  }

  // --- Resize handler ---
  var resizeTimer;
  var initialWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ((initialWidth > 990 && window.innerWidth <= 990) ||
          (initialWidth <= 990 && window.innerWidth > 990)) {
        location.reload();
        return;
      }
      instances.forEach(function (inst) {
        inst.app.setSize(window.innerWidth, window.innerHeight);
      });
    }, 200);
  });

  // --- Sync all canvases with carousel ---
  var prodottiSection = document.querySelector('#prodotti');

  function syncWithCarousel() {
    var trackX = gsap.getProperty(track, 'x') || 0;
    var slideWidth = window.innerWidth;

    // Only show canvases when #prodotti-wrap top has reached viewport top
    var wrap = document.querySelector('#prodotti-wrap');
    var wrapRect = wrap ? wrap.getBoundingClientRect() : null;
    var sectionVisible = wrapRect && wrapRect.top <= 0 && wrapRect.bottom > window.innerHeight * 0.5;

    // Fade-in: calculate opacity based on how far the wrap top has scrolled past viewport
    // wrapRect.top goes from positive (below) to 0 (at top) to negative (scrolled past)
    // Fade zone: from wrapRect.top = window.innerHeight * 0.3 down to 0
    var fadeZone = window.innerHeight * 0.3;
    var fadeOpacity = wrapRect ? Math.min(1, Math.max(0, (fadeZone - wrapRect.top) / fadeZone)) : 0;

    if (!sectionVisible) {
      instances.forEach(function (inst) {
        inst.canvas.style.visibility = 'hidden';
        inst.canvas.style.opacity = '0';
        inst.shadow.style.visibility = 'hidden';
      });
      requestAnimationFrame(syncWithCarousel);
      return;
    }

    instances.forEach(function (inst) {
      var i = inst.slideIndex;

      var slideCenter = i * slideWidth + slideWidth / 2 + trackX;
      var viewCenter = slideWidth / 2;
      var distRaw = (slideCenter - viewCenter) / slideWidth;
      var distNorm = Math.min(Math.abs(distRaw), 1);

      var bottleParallax = distRaw > 0 ? distRaw * slideWidth * -0.5 : 0;

      // Slide-up animation: translate Y from 60px to 0 during fade-in
      var slideUpY = (1 - fadeOpacity) * 60;
      inst.canvas.style.transform = 'translateX(' + (trackX + i * slideWidth + bottleParallax) + 'px) translateY(' + slideUpY + 'px)';

      var scaleFactor = 1 - distNorm * 0.25;
      var sf = baseScale * scaleFactor * inst.scaleMultiplier;
      if (inst.preserveProportions) {
        inst.bottle.scale.x = sf;
        inst.bottle.scale.y = sf * inst.ratioY;
        inst.bottle.scale.z = sf * inst.ratioZ;
      } else {
        inst.bottle.scale.x = sf;
        inst.bottle.scale.y = sf;
        inst.bottle.scale.z = sf;
      }

      // Apply fade-in opacity (combined with off-center dimming)
      var centerOpacity = distNorm > 0.1 ? (1 - distNorm * 0.3) : 1;
      inst.canvas.style.opacity = String(fadeOpacity * centerOpacity);
      inst.canvas.style.filter = distNorm > 0.1 ? 'blur(' + (distNorm * 1.5) + 'px)' : 'none';
      inst.canvas.style.visibility = 'visible';
      inst.canvas.style.transition = 'opacity 0.4s ease';

      var shadowScale = scaleFactor;
      var shadowOpacity = fadeOpacity * (1 - distNorm * 0.7);
      inst.shadow.style.transform = 'translateX(calc(-50% + ' + (trackX + i * slideWidth + bottleParallax) + 'px)) scale(' + shadowScale + ')';
      inst.shadow.style.opacity = shadowOpacity;
      inst.shadow.style.visibility = sectionVisible ? 'visible' : 'hidden';

      // Only rotate when slide is active (centered)
      if (distNorm < 0.3) {
        if (!inst.autoRotate.isActive()) inst.autoRotate.play();
      } else {
        if (inst.autoRotate.isActive()) inst.autoRotate.pause();
      }
    });

    requestAnimationFrame(syncWithCarousel);
  }

  syncWithCarousel();

  // --- Mouse drag-to-rotate on active 3D product ---
  (function () {
    var isDragging = false;
    var startX = 0;
    var startY = 0;
    var startRotY = 0;
    var startRotX = 0;
    var activeInst = null;
    var sensitivity = 0.008;

    function getActiveInstance() {
      var trackX = gsap.getProperty(track, 'x') || 0;
      var slideWidth = window.innerWidth;
      var best = null;
      var bestDist = Infinity;
      instances.forEach(function (inst) {
        var slideCenter = inst.slideIndex * slideWidth + slideWidth / 2 + trackX;
        var dist = Math.abs(slideCenter - slideWidth / 2);
        if (dist < bestDist) { bestDist = dist; best = inst; }
      });
      return bestDist < slideWidth * 0.3 ? best : null;
    }

    prodottiSection.addEventListener('mousedown', function (e) {
      activeInst = getActiveInstance();
      if (!activeInst) return;

      // Check if mouse is roughly in the center (where the 3D product is)
      var cx = window.innerWidth / 2;
      var cy = window.innerHeight / 2;
      if (Math.abs(e.clientX - cx) > window.innerWidth * 0.3) return;

      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;
      startRotY = activeInst.bottle.rotation.y;
      startRotX = activeInst.bottle.rotation.x;

      // Pause auto-rotation during drag
      if (activeInst.autoRotate.isActive()) activeInst.autoRotate.pause();

      prodottiSection.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging || !activeInst) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      activeInst.bottle.rotation.y = startRotY + dx * sensitivity;
      activeInst.bottle.rotation.x = startRotX + dy * sensitivity * 0.5;

      // Clamp X rotation to avoid flipping
      activeInst.bottle.rotation.x = Math.max(-0.4, Math.min(0.4, activeInst.bottle.rotation.x));
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging || !activeInst) return;
      isDragging = false;
      prodottiSection.style.cursor = '';

      // Smooth return X rotation to original, resume auto-rotate
      gsap.to(activeInst.bottle.rotation, {
        x: -0.01,
        duration: 0.8,
        ease: 'power2.out',
        onComplete: function () {
          var inst = getActiveInstance();
          if (inst && inst.autoRotate) inst.autoRotate.play();
        },
      });

      activeInst = null;
    });

    // Change cursor when hovering over the 3D area
    prodottiSection.addEventListener('mousemove', function (e) {
      if (isDragging) return;
      var cx = window.innerWidth / 2;
      var inst = getActiveInstance();
      if (inst && Math.abs(e.clientX - cx) < window.innerWidth * 0.2) {
        prodottiSection.style.cursor = 'grab';
      } else {
        prodottiSection.style.cursor = '';
      }
    });

    prodottiSection.addEventListener('mouseleave', function () {
      if (isDragging && activeInst) {
        isDragging = false;
        prodottiSection.style.cursor = '';
        gsap.to(activeInst.bottle.rotation, {
          x: -0.01,
          duration: 0.8,
          ease: 'power2.out',
          onComplete: function () {
            var inst = getActiveInstance();
            if (inst && inst.autoRotate) inst.autoRotate.play();
          },
        });
        activeInst = null;
      }
    });
  })();

  // Expose for debugging
  window._splineBottles = instances.map(function (inst) { return inst.bottle; });

  /* ==========================================
     DEBUG PANEL — Per riattivare: cambiare false → true
     Usa il selettore per scegliere quale slide debuggare
     ========================================== */
  var SHOW_DEBUG = false;
  if (SHOW_DEBUG && instances.length > 0) {
    var activeDebugIndex = 0;
    var activeBottle = instances[0].bottle;

    var panel = document.createElement('div');
    panel.id = 'spline-debug';
    panel.innerHTML = `
      <style>
        #spline-debug {
          position: fixed; top: 10px; right: 10px; z-index: 99999;
          background: rgba(0,0,0,0.88); color: #fff; padding: 16px 20px;
          border-radius: 10px; font-family: monospace; font-size: 13px;
          width: 280px; backdrop-filter: blur(8px);
          pointer-events: all; max-height: 90vh; overflow-y: auto;
        }
        #spline-debug h4 { margin: 0 0 12px; font-size: 14px; color: #9FB4C0; }
        #spline-debug label { display: flex; align-items: center; gap: 8px; margin: 6px 0; }
        #spline-debug label span { width: 70px; flex-shrink: 0; }
        #spline-debug input[type=range] { flex: 1; accent-color: #9FB4C0; }
        #spline-debug .val { width: 55px; text-align: right; font-size: 12px; color: #ccc; }
        #spline-debug hr { border: none; border-top: 1px solid rgba(255,255,255,0.15); margin: 10px 0; }
        #spline-debug select {
          width: 100%; padding: 6px; margin-bottom: 10px; border-radius: 6px;
          background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2);
          color: #fff; font-family: monospace; font-size: 13px;
        }
        #spline-debug button {
          width: 100%; padding: 8px; margin-top: 10px; border: none; border-radius: 6px;
          background: #9FB4C0; color: #000; font-weight: bold; font-size: 13px; cursor: pointer;
        }
        #spline-debug button:hover { background: #b8cdd8; }
        #spline-debug .recorded { margin-top: 8px; font-size: 11px; color: #7be07b; display: none; }
      </style>
      <h4>3D Position Debug</h4>

      <select id="dbg-slide-select">
        ${instances.map(function(inst, i){ return '<option value="' + i + '">Slide ' + (i+1) + '</option>'; }).join('')}
      </select>

      <label><span>Pos X</span><input type="range" id="dbg-px" min="-500" max="500" step="1" value="0"><span class="val" id="dbg-px-v">0</span></label>
      <label><span>Pos Y</span><input type="range" id="dbg-py" min="-500" max="500" step="1" value="0"><span class="val" id="dbg-py-v">0</span></label>
      <label><span>Pos Z</span><input type="range" id="dbg-pz" min="-500" max="500" step="1" value="0"><span class="val" id="dbg-pz-v">0</span></label>

      <hr>

      <label><span>Rot X</span><input type="range" id="dbg-rx" min="-3.14" max="3.14" step="0.01" value="0"><span class="val" id="dbg-rx-v">0</span></label>
      <label><span>Rot Y</span><input type="range" id="dbg-ry" min="-3.14" max="3.14" step="0.01" value="0"><span class="val" id="dbg-ry-v">0</span></label>
      <label><span>Rot Z</span><input type="range" id="dbg-rz" min="-3.14" max="3.14" step="0.01" value="0"><span class="val" id="dbg-rz-v">0</span></label>

      <hr>

      <label><span>Scale</span><input type="range" id="dbg-s" min="0.1" max="3" step="0.05" value="1"><span class="val" id="dbg-s-v">1</span></label>

      <button id="dbg-record">Registra valori</button>
      <div class="recorded" id="dbg-msg">Valori copiati e stampati in console!</div>
    `;
    document.body.appendChild(panel);

    function updateSliders(bottle) {
      document.getElementById('dbg-px').value = bottle.position.x;
      document.getElementById('dbg-px-v').textContent = bottle.position.x.toFixed(0);
      document.getElementById('dbg-py').value = bottle.position.y;
      document.getElementById('dbg-py-v').textContent = bottle.position.y.toFixed(0);
      document.getElementById('dbg-pz').value = bottle.position.z;
      document.getElementById('dbg-pz-v').textContent = bottle.position.z.toFixed(0);
      document.getElementById('dbg-rx').value = bottle.rotation.x;
      document.getElementById('dbg-rx-v').textContent = bottle.rotation.x.toFixed(2);
      document.getElementById('dbg-ry').value = bottle.rotation.y;
      document.getElementById('dbg-ry-v').textContent = bottle.rotation.y.toFixed(2);
      document.getElementById('dbg-rz').value = bottle.rotation.z;
      document.getElementById('dbg-rz-v').textContent = bottle.rotation.z.toFixed(2);
      document.getElementById('dbg-s').value = bottle.scale.x;
      document.getElementById('dbg-s-v').textContent = bottle.scale.x.toFixed(2);
    }

    // Init with slide 1
    updateSliders(activeBottle);

    // Slide selector
    document.getElementById('dbg-slide-select').addEventListener('change', function () {
      activeDebugIndex = parseInt(this.value);
      var inst = instances.find(function (i) { return i.slideIndex === activeDebugIndex; });
      if (inst) {
        activeBottle = inst.bottle;
        updateSliders(activeBottle);
      }
    });

    function bindSlider(id, prop, valId, objType) {
      document.getElementById(id).addEventListener('input', function () {
        var v = parseFloat(this.value);
        if (objType === 'position') activeBottle.position[prop] = v;
        else if (objType === 'rotation') activeBottle.rotation[prop] = v;
        document.getElementById(valId).textContent = Math.abs(v) < 10 ? v.toFixed(2) : v.toFixed(0);
      });
    }

    bindSlider('dbg-px', 'x', 'dbg-px-v', 'position');
    bindSlider('dbg-py', 'y', 'dbg-py-v', 'position');
    bindSlider('dbg-pz', 'z', 'dbg-pz-v', 'position');
    bindSlider('dbg-rx', 'x', 'dbg-rx-v', 'rotation');
    bindSlider('dbg-ry', 'y', 'dbg-ry-v', 'rotation');
    bindSlider('dbg-rz', 'z', 'dbg-rz-v', 'rotation');

    document.getElementById('dbg-s').addEventListener('input', function () {
      var v = parseFloat(this.value);
      activeBottle.scale.x = v;
      activeBottle.scale.y = v;
      activeBottle.scale.z = v;
      document.getElementById('dbg-s-v').textContent = v.toFixed(2);
    });

    document.getElementById('dbg-record').addEventListener('click', function () {
      var data = {
        slide: activeDebugIndex + 1,
        position: { x: activeBottle.position.x, y: activeBottle.position.y, z: activeBottle.position.z },
        rotation: { x: activeBottle.rotation.x, y: activeBottle.rotation.y, z: activeBottle.rotation.z },
        scale: activeBottle.scale.x,
      };
      console.log('=== SPLINE 3D — SLIDE ' + data.slide + ' RECORDED VALUES ===');
      console.log(JSON.stringify(data, null, 2));

      var text =
        'position.x = ' + data.position.x.toFixed(1) + ';\n' +
        'position.y = ' + data.position.y.toFixed(1) + ';\n' +
        'position.z = ' + data.position.z.toFixed(1) + ';\n' +
        'rotation.x = ' + data.rotation.x.toFixed(3) + ';\n' +
        'rotation.y = ' + data.rotation.y.toFixed(3) + ';\n' +
        'rotation.z = ' + data.rotation.z.toFixed(3) + ';\n' +
        'scale = ' + data.scale.toFixed(2) + ';';

      navigator.clipboard.writeText(text).catch(function () {});
      console.log(text);

      var msgEl = document.getElementById('dbg-msg');
      msgEl.style.display = 'block';
      setTimeout(function () { msgEl.style.display = 'none'; }, 3000);
    });
  } // end SHOW_DEBUG
})();
